import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "fileInput", "submitButton", "fileName", "modal", "previewContainer"]

    connect() {
        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = true
        }

        // Close modal when clicking outside (only if modal exists)
        if (this.hasModalTarget) {
            document.addEventListener('click', this.handleOutsideClick.bind(this))
            document.addEventListener('keydown', this.handleEscapeKey.bind(this))
        }
    }

    disconnect() {
        if (this.hasModalTarget) {
            document.removeEventListener('click', this.handleOutsideClick.bind(this))
            document.removeEventListener('keydown', this.handleEscapeKey.bind(this))
        }
    }

    handleOutsideClick(event) {
        if (this.isModalOpen() && !this.modalTarget.contains(event.target) && !event.target.closest('[data-action*="vcard-import#openModal"]')) {
            this.closeModal()
        }
    }

    handleEscapeKey(event) {
        if (this.isModalOpen() && event.key === 'Escape') {
            this.closeModal()
        }
    }

    isModalOpen() {
        return this.hasModalTarget && !this.modalTarget.classList.contains('hidden')
    }

    openModal() {
        if (this.hasModalTarget) {
            this.modalTarget.classList.remove('hidden')
            document.body.classList.add('overflow-hidden')
        }
    }

    closeModal() {
        if (this.hasModalTarget) {
            this.modalTarget.classList.add('hidden')
            document.body.classList.remove('overflow-hidden')
        }
    }

    fileSelected() {
        const file = this.fileInputTarget.files[0]

        if (file) {
            this.fileNameTarget.textContent = file.name

            if (this.hasSubmitButtonTarget) {
                this.submitButtonTarget.disabled = false
            }

            // Check if it's an image file
            const isImage = file.type.startsWith("image/") || file.name.match(/\.(jpg|jpeg|png|gif|webp)$/i)

            if (isImage && this.hasPreviewContainerTarget) {
                // Read the file and show preview
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.showPreview(e.target.result)
                }
                reader.onerror = () => {
                    console.error("Error reading file")
                    this.clearPreview()
                }
                reader.readAsDataURL(file)
            } else {
                this.clearPreview()
            }
        } else {
            // No file selected
            this.fileNameTarget.textContent = "No file selected"
            
            if (this.hasSubmitButtonTarget) {
                this.submitButtonTarget.disabled = true
            }

            this.clearPreview()
        }
    }

    showPreview(dataUrl) {
        if (!this.hasPreviewContainerTarget) return

        // Create a new image element
        const img = document.createElement('img')
        img.src = dataUrl
        img.alt = "Business Card Preview"
        img.className = "rounded-lg border border-slate-300 shadow-sm object-cover size-[200px]"

        // Clear any existing content and add the new image
        this.previewContainerTarget.innerHTML = ''
        this.previewContainerTarget.appendChild(img)
    }

    clearPreview() {
        if (this.hasPreviewContainerTarget) {
            this.previewContainerTarget.innerHTML = ''
        }
    }

    submit(event) {
        if (!this.fileInputTarget.files[0]) {
            event.preventDefault()
            return
        }

        // Form will submit normally to the import_vcard action
    }
}
